import React, { useState, useEffect } from "react";
import Input from "../../components/Input";
import InputSelect from "../../components/InputSelect";
import InputDate from "../../components/InputDate";
import InputMask from "../../components/InputMask";
import InputCurrency from "../../components/InputCurrency";
import InputCheckbox from "../../components/InputCheckbox";
import { Row, Col, Typography } from "antd";
import { LoadingOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { normalizeText, normalizeTextWithNumber } from "../../utils/removeMask";

export default function FormPersonal({
  register,
  control,
  errors,
  onPrevious,
  onNext,
  loading,
  setValue,
}) {
  function fnRemoveCaracter(e) {
    return normalizeText(e.target.value);
  }

  const [neighborhood, setNeighborhood] = useState();
  const [street, setStreet] = useState();
  const [complement, setComplement] = useState();

  function fnRemoveCaracterNeighborhood(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setNeighborhood(value);
  }

  function fnRemoveCaracterStreet(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setStreet(value);
  }

  function fnRemoveCaracterComplement(e) {
    const value = normalizeTextWithNumber(e.target.value);
    setComplement(value);
  }

  async function getAddress(inputCep) {
    const cep = inputCep.toString().replace(/-/g, "");
    const cepValidation = /^[0-9]{8}$/;

    if (cepValidation.test(cep)) {
      const response = await fetch(`https://viacep.com.br/ws/${cep}/json`).then(
        (res) => res.json()
      );

      if (response.uf) {
        setValue("state", response.uf, { shouldValidate: true });
        setValue("street", response.logradouro, {
          shouldValidate: true,
        });
        setValue("city", response.localidade, { shouldValidate: true });
        setValue("neighborhood", response.bairro, {
          shouldValidate: true,
        });
      } else {
        ["zip", "state", "address", "city", "neighborhood"].forEach((field) =>
          setValue(field, "", { shouldValidate: true })
        );
      }
    } else {
      ["zip", "state", "address", "city", "neighborhood"].forEach((field) =>
        setValue(field, "", { shouldValidate: true })
      );
    }
  }

  return (
    <div key="formCompany">
      <Row gutter={16} className="__auth-mb-25">
        <Col xs={24}>
          <div style={{ margin: "0px 10px", marginBottom: "40px" }}>
            <Typography.Title level={4}>
              Preencha com os dados da sua empresa
            </Typography.Title>
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label="Nome Fantasia"
            placeholder="Digite o nome fantasia"
            register={register("tradeName")}
            required
            error={errors.tradeName?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            label="Nome Empresarial"
            placeholder="Digite o nome empresarial"
            register={register("legalName")}
            required
            error={errors.legalName?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            name="taxId"
            type="tel"
            control={control}
            label="CNPJ"
            placeholder="Digite o seu CNPJ"
            mask="99.999.999/9999-99"
            maskChar={null}
            required
            error={errors.taxId?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <div key="divInput">
            <Input
              key="companyEmail"
              label="Email para seu login"
              placeholder="Digite o seu email da empresa"
              register={register("companyEmail", {
                setValueAs: (value) => value.replace(/ /g, ""),
              })}
              required
              error={errors.companyEmail?.message}
            />
          </div>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="companyType"
            label="Tipo de empresa"
            placeholder="Selecione o tipo de empresa"
            name="companyType"
            required
            error={errors.companyType?.message}
            onChange={() => {
              setValue("Contract", undefined);
              setValue("IDENTIFICATION", undefined);
              setValue("ENTREPRENEUR_REQUIREMENT", undefined);
              setValue("MINUTES_OF_ELECTION", undefined);
            }}
            options={[
              { value: "MEI", label: "MEI" },
              { value: "ME", label: "ME" },
              { value: "LIMITED", label: "Empresa Limitada" },
              { value: "INDIVIDUAL", label: "Empresa Individual" },
              { value: "ASSOCIATION", label: "Associação" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputSelect
            control={control}
            key="cadastralSituation"
            label="Situação cadastral"
            placeholder="Selecione a situação cadastral da empresa"
            name="cadastralSituation"
            required
            error={errors.cadastralSituation?.message}
            options={[
              { value: "ATIVA", label: "Ativa" },
              { value: "SUSPENSA", label: "Suspensa" },
              { value: "INAPTA", label: "Inapta" },
              { value: "BAIXADA", label: "Baixada" },
              { value: "NULA", label: "Nula" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputMask
            name="codeActivity"
            label="Código CNAE"
            placeholder="Digite o código CNAE"
            required
            error={errors.codeActivity?.message}
            control={control}
            mask="9999-9/99"
            maskChar={null}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputDate
            label="Data de criação"
            placeholder="Digite a data de criação"
            control={control}
            required
            name="constitutionDate"
            maxDate={new Date()}
            minDate={new Date("1700")}
            error={errors.constitutionDate?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputCurrency
            label="Patrimônio"
            name="financialEquity"
            type="tel"
            placeholder="Insira o patrimônio"
            allowNegative={false}
            control={control}
            error={errors.financialEquity?.message}
            defaultValue={0}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <InputCurrency
            label="Faturamento mensal"
            name="financialProfit"
            type="tel"
            placeholder="Insira o faturamento mensal"
            allowNegative={false}
            control={control}
            error={errors.financialProfit?.message}
            defaultValue={0}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginTop: "50px" }}>
          <InputMask
            key="zipCode"
            name="zipCode"
            placeholder="Digite seu cep"
            label="CEP"
            error={errors.zipCode?.message}
            control={control}
            required
            mask="99999-999"
            onChange={({ target }) => getAddress(target.value)}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginTop: "50px" }}>
          <InputSelect
            control={control}
            key="state"
            label="Estado"
            placeholder="Selecione seu estado"
            name="state"
            required
            error={errors.state?.message}
            options={[
              { value: "AC", label: "Acre" },
              { value: "AL", label: "Alagoas" },
              { value: "AP", label: "Amapá" },
              { value: "AM", label: "Amazonas" },
              { value: "BA", label: "Bahia" },
              { value: "CE", label: "Ceará" },
              { value: "DF", label: "Distrito Federal" },
              { value: "ES", label: "Espírito Santo" },
              { value: "GO", label: "Goías" },
              { value: "MA", label: "Maranhão" },
              { value: "MT", label: "Mato Grosso" },
              { value: "MS", label: "Mato Grosso do Sul" },
              { value: "MG", label: "Minas Gerais" },
              { value: "PA", label: "Pará" },
              { value: "PB", label: "Paraíba" },
              { value: "PR", label: "Paraná" },
              { value: "PE", label: "Pernambuco" },
              { value: "PI", label: "Piauí" },
              { value: "RJ", label: "Rio de Janeiro" },
              { value: "RN", label: "Rio Grande do Norte" },
              { value: "RS", label: "Rio Grande do Sul" },
              { value: "RO", label: "Rondônia" },
              { value: "RR", label: "Roraíma" },
              { value: "SC", label: "Santa Catarina" },
              { value: "SP", label: "São Paulo" },
              { value: "SE", label: "Sergipe" },
              { value: "TO", label: "Tocantins" },
            ]}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            key="city"
            label="Cidade"
            placeholder="Digite sua cidade"
            register={register("city")}
            required
            error={errors.city?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12}>
          <Input
            key="neighborhood"
            label="Bairro"
            value={neighborhood}
            placeholder="Selecione seu bairro"
            register={register("neighborhood")}
            required
            error={errors.neighborhood?.message}
            // onChange={(e) => fnRemoveCaracterNeighborhood(e)}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={24}>
          <Input
            key="street"
            value={street}
            label="Logradouro"
            placeholder="Digite seu endereço (rua, avenida, etc)"
            register={register("street")}
            required
            error={errors.street?.message}
            // onChange={(e) => fnRemoveCaracterStreet(e)}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={6}>
          <Input
            key="number"
            label="Número"
            placeholder="Digite seu número"
            register={register("number")}
            required
            error={errors.number?.message}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={18}>
          <Input
            key="complement"
            value={complement}
            label="Complemento"
            placeholder="Digite seu complemento"
            register={register("complement")}
            error={errors.complement?.message}
            // onChange={(e) => fnRemoveCaracterComplement(e)}
          />
        </Col>
        <InputCheckbox
          label="FATCA"
          register={register("fatca")}
          name="fatca"
          error={errors.fatca?.message}
          adornment={
            <>
              <div style={{ margin: "10px 5px 0px" }}>
                <strong style={{ display: "flex", margin: "16px 0" }}>
                  Empresa possui domicílio fiscal no exterior ou os sócios
                  atendem ao critério para US Person?
                </strong>
                <p>
                  - Pessoa que se enquadra em pelo menos uma das condições
                  abaixo:{" "}
                </p>
                <p>- É residente fiscal nos EUA; </p>
                <p>- Nasceu nos EUA; </p>
                <p>- Possui cidadania ou nacionalidade americana;</p>
                <p>- Possui visto de residência ("Green Card");</p>
                <p>- É residente permanente nos EUA;</p>
                <p>
                  - Possui participação societária (mais de 10%) em alguma
                  empresa nos EUA;
                </p>
              </div>
            </>
          }
        />
      </Row>

      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-outlined"
            onClick={onPrevious}
            disabled={loading}
          >
            Voltar
          </button>
        </Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            onClick={onNext}
            disabled={loading}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>
    </div>
  );
}
